export const STAGES_MAP = {
  immediate: { key: "immediate", label: "Send Immediately", position: -1 },
  preboarding: { key: "preboarding", label: "Preboarding", position: 1 },
  day1: { key: "day1", label: "Day 1", position: 2 },
  week1: { key: "week1", label: "Week 1", position: 4 },
  week2: { key: "week2", label: "Week 2", position: 5 },
  month1: { key: "month1", label: "Month 1", position: 6 },
  month2: { key: "month2", label: "Month 2", position: 7 },
  month3: { key: "month3", label: "Month 3", position: 8 },
  afterMonth3: { key: "afterMonth3", label: "3+ Months", position: 9 },
  afterMonth6: { key: "afterMonth6", label: "6+ Months", position: 10 },
  afterMonth12: { key: "afterMonth12", label: "Past 1 Year", position: 11 },
  dependency: { key: "dependency", label: "After Task Completion", position: 12 },
} as const;

export const ALL_STAGES = [
  STAGES_MAP.immediate,
  STAGES_MAP.preboarding,
  STAGES_MAP.day1,
  STAGES_MAP.week1,
  STAGES_MAP.week2,
  STAGES_MAP.month1,
  STAGES_MAP.month2,
  STAGES_MAP.month3,
  STAGES_MAP.afterMonth3,
  STAGES_MAP.afterMonth6,
  STAGES_MAP.afterMonth12,
  STAGES_MAP.dependency,
] as const;

export const ALL_STAGES_MINUS_IMMEDIATE_DEPENDENCY = [
  STAGES_MAP.preboarding,
  STAGES_MAP.week1,
  STAGES_MAP.week2,
  STAGES_MAP.month1,
  STAGES_MAP.month2,
  STAGES_MAP.month3,
  STAGES_MAP.afterMonth3,
  STAGES_MAP.afterMonth6,
  STAGES_MAP.afterMonth12,
] as const;

export type StageKey = typeof ALL_STAGES[number]["key"];
